<div fxLayout="row" style="margin-bottom: .5em;">
  <span style="padding-top: .5em;" class="folio-header-style">{{isCreateTeam ?
    (MY_CONSTANT.LABEL_TEAMS_HEADER_TITLE_CREATE_TEAM) : (MY_CONSTANT.LABEL_TEAMS_HEADER_TITLE_TEAM_DETAILS)}}</span>

</div>
<mat-divider></mat-divider>

<div *ngIf="fetchingData">{{MY_CONSTANT.LABEL_FETCHING}}</div>

<div fxLayoutAlign="center" *ngIf="!fetchingData" fxLayout="column" [ngStyle]="{'marginTop': '1rem'}">

  <mat-card [ngClass]="{'center-card': true}">
    <!-- Input boxes view -->
    <div fxLayoutAlign="center" fxLayout="row" fxLayout.xs="column" fxLayoutGap="28px"
      [ngStyle]="{'margin-left': isCreateTeam ? '-1.5rem' : '0rem'}">
      <mat-form-field [style.width]="'400px'">
        <input matInput placeholder="{{MY_CONSTANT.LABEL_TEAMS_PLACEHOLDER_TEAM_NAME}}" maxlength="40"
          [formControl]="teamNameFormControl" #teamName autocomplete="off">
        <mat-error *ngIf="teamNameFormControl.hasError('required')">
          Team Name is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field [style.width]="'400px'">
        <mat-label>{{MY_CONSTANT.LABEL_TEAMS_PLACEHOLDER_ADMINISTRATOR}}</mat-label>
        <mat-select [(value)]="selected" [formControl]="adminNameFormControl">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let option of options" [value]="option.USERNAME">{{option.USERNAME}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Drag & Drop view -->
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
      <!-- drag view -->
      <div class="example-container">
        <div class="example-title">{{MY_CONSTANT.LABEL_TEAMS_TITLE_USERS}}&nbsp;({{usersSearchList.length}})
          <input [ngClass]="{'custom-input': true}" (keyup)="applyFilter($event.target.value)"
            placeholder="{{MY_CONSTANT.LABEL_TEAMS_PLACEHOLDER_FILTER}}">
        </div>

        <div id="dragList" cdkDropList #todoList="cdkDropList" [cdkDropListData]="usersSearchList"
          [cdkDropListConnectedTo]="[doneList]" class="example-list" (cdkDropListDropped)="drop($event)"
          (exited)="exitedData($event)" (started)="started($event)">
          <div class="example-box" *ngFor="let user of usersSearchList" cdkDrag>{{user.USERNAME}}</div>
        </div>
      </div>

      <!-- drop view -->
      <div class="example-container">
        <div class="example-title">{{MY_CONSTANT.LABEL_TEAMS_TITLE_TEAM}}&nbsp;({{done.length}})</div>

        <div id="dropList" cdkDropList #doneList="cdkDropList" [cdkDropListData]="done"
          [cdkDropListConnectedTo]="[todoList]" class="example-list" (cdkDropListDropped)="drop($event)">
          <div class="example-box" *ngFor="let item of done" cdkDrag>
            <span>{{item.USERNAME}}</span>
            <mat-icon (click)="editUser(item)" matTooltip="Edit user data" style="font-size: 18px;">edit</mat-icon>
          </div>
        </div>

      </div>
    </div>

    <div class="flex-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" style="margin-bottom: 5rem;">
      <button mat-raised-button style="margin-right: 1rem; margin-top: 1rem;"
        (click)="onCancelButtonClick()">{{MY_CONSTANT.LABEL_BTN_TEXT_CANCEL}}</button>
      <button mat-raised-button color="accent" style="margin-right: 1rem; margin-top: 1rem;" (click)="onSubmitFn()"
        [disabled]="!done.length">{{isCreateTeam ? (MY_CONSTANT.LABEL_BTN_TEXT_CREATE) :
        (MY_CONSTANT.LABEL_BTN_TEXT_UPDATE)}}</button>
    </div>
  </mat-card>

</div>

  <div>
    <app-user-edit-popup #editUserComponent (userUpdated)="updateUser($event)"></app-user-edit-popup>
  </div>
